/**
 * OnlineIndicator — Container для visual badge offline-first sync status.
 *
 * Subscribes к useOnlineStatus hook (Phase A5 Step 1), renders OnlineIndicatorView.
 *
 * MVP: non-interactive badge (div role=status). Phase 9+ — конвертация в button
 * с detailed pending list modal (per ADR-0019 §Q11.5).
 *
 * Placement (closes ADR-0019 OQ1):
 *   - Header (sticky top, non-Home screens) — absolute-positioned top-right
 *   - HomeHeader (Home screen) — appended после language switcher
 *
 * References: ADR-0005 (Container/Presenter split), ADR-0019 §Q11.5, §Q11.6
 */

import { useOnlineStatus } from '../../lib/offline/sync/useOnlineStatus';
import { OnlineIndicatorView } from './OnlineIndicatorView';

export function OnlineIndicator() {
  const { online, pendingCount } = useOnlineStatus();
  return <OnlineIndicatorView online={online} pendingCount={pendingCount} />;
}
